import { render } from "./editProfileComponent.vue?vue&type=template&id=5b045dc4"
import script from "./editProfileComponent.vue?vue&type=script&lang=js"
export * from "./editProfileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__